import { render, staticRenderFns } from "./DocumentCategoriesLayout.vue?vue&type=template&id=1a26e73c&"
import script from "./DocumentCategoriesLayout.vue?vue&type=script&lang=js&"
export * from "./DocumentCategoriesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports